import Vue from 'vue'
import moment from 'moment'

function getObjectPath (object, path, defaultResponse) {
  if (object) {
    let bits = path.split('.')
    for (let key of bits) {
      try {
        if (Object.keys(object).indexOf(key) !== -1) {
          object = object[key]
        } else {
          return defaultResponse
        }
      } catch (e) {
        if (e instanceof TypeError) {
          return defaultResponse
        }
        throw e
      }
    }
    return object
  }
  return defaultResponse
}

function sortDaysEvents (day) {
  if (day && day.items) {
    return Object.values(day.items).sort((a, b) => {
      if (a.start_time > b.start_time) { return 1 }
      if (a.start_time < b.start_time) { return -1 }
      return 0
    })
  } else {
    return null
  }
}

export default {
  state: {
    objects: {},
    detail: {},
    calendars: {}
  },
  mutations: {
    addAppointments (state, appointments) {
      let updatedDays = []
      // could maybe do this async?
      appointments.forEach((appointment) => {
        if (!appointment.id) { return null }
        let practitionerId = appointment.practitioner
        if (appointment.start_time && appointment.start_time.indexOf('T') > -1) {
          // prepare:
          let dt = appointment.start_time.split('T')[0]
          updatedDays.push([practitionerId, dt])
          if (!(practitionerId in state.calendars)) {
            let newCalendar = {title: '', dates: {}, facets: {}}
            Vue.set(state.calendars, practitionerId, newCalendar)
          }
          if (!(dt in state.calendars[practitionerId].dates)) {
            Vue.set(state.calendars[practitionerId].dates, dt, {'list': [], 'items': {}})
          }

          // format appointment:
          let startMoment = moment(appointment.start_time)
          let endMoment = moment(appointment.end_time)
          appointment.dt = dt
          appointment.start = startMoment.format('HH:mm')
          appointment.end = endMoment.format('HH:mm')
          appointment.duration = moment.duration(
            endMoment.diff(startMoment)
          ).minutes()
          if (!appointment.dates) {
            appointment.dates = [dt]
          } else {
            if (appointment.dates.indexOf(dt) === -1) {
              appointment.dates.push(dt)
            }
          }

          let day = state.calendars[practitionerId].dates[dt]
          // add to day lookup:
          Vue.set(day.items, appointment.id, appointment)
          // insert into the ordered day:
          if (!day.list || day.list.length === 0) {
            Vue.set(day, 'list', [appointment])
          } else {
            let existsIndex = day.list.findIndex((appt) => {
              let compareString1 = `${appt.id}${appt.start_time}${appt.end_time}`
              let compareString2 = `${appointment.id}${appointment.start_time}${appointment.end_time}`
              if (compareString1 === compareString2) { return true }
            })
            let exists = existsIndex > -1
            if (exists) {
              // console.log('updating', existsIndex, appointment)
              Vue.set(day.list, existsIndex, appointment)
              // day.list[existsIndex] = appointment
            } else {
              let insertIndex = day.list.findIndex((appt) => {
                return appointment.start_time <= appt.start_time
              })
              if (insertIndex > -1) {
                day.list.splice(insertIndex, 0, appointment)
              } else {
                day.list.push(appointment)
              }
            }
          }
        } else {
          console.error('no start time found on appointment')
        }
        // add to KV:
        Vue.set(state.objects, appointment.id, appointment)
      })
      // sort any changed days
      // let's rather do: insertat
      // updatedDays.forEach((item) => {
      //   let practitionerId = item[0]
      //   let dt = item[1]
      //   let day = getObjectPath(state, `calendars.${practitionerId}.dates.${dt}`, null)
      //   let sorted = sortDaysEvents(day)
      //   if (sorted) {
      //     Vue.set(day, 'list', sorted)
      //   }
      // })
    },
    removeAppointment (state, appointmentId) {
      if (appointmentId in state.objects) {
        let appt = state.objects[appointmentId]
        // remove from calendar cash
        if (appt.practitioner && (appt.practitioner in state.calendars)) {
          // delete from calendar items
          let path = `calendars.${appt.practitioner}.dates.${appt.dt}.items`
          let item = getObjectPath(state, path)
          Vue.delete(item, appointmentId)

          // re-sort calendar list
          let day = getObjectPath(state, `calendars.${appt.practitioner}.dates.${appt.dt}`, null)
          let sorted = sortDaysEvents(day)
          if (sorted) {
            Vue.set(day, 'list', sorted)
          }
        }
        // delete object
        Vue.delete(state.objects, appointmentId)
      }
    },
    cleanAppointment (state, {id, practitionerId, dt}) {
      // if (practitionerId in state.calendars) {
      let path = `calendars.${practitionerId}.dates.${dt}.items`
      let item = getObjectPath(state, path)
      if (item) { Vue.delete(item, id) }

      // re-sort calendar list
      let day = getObjectPath(state, `calendars.${practitionerId}.dates.${dt}`, null)
      let sorted = sortDaysEvents(day)
      if (sorted) {
        Vue.set(day, 'list', sorted)
      }
      // }
    }
  },
  actions: {
    async fetchAppointments ({commit, getters}, appointmentIds) {
      if (appointmentIds && appointmentIds.length > 0) {
        let base = process.env.APPOINTMENTGURU_API_ROOT
        let path = '/api/v3/practitioner/appointments/'
        let url = base + path + '?id-in=' + appointmentIds.join(',')
        let options = {
          headers: {
            'Authorization': 'Bearer ' + getters.token
          }
        }
        let result = await fetch(url, options)
        if (result.ok) {
          let data = await result.json()
          commit('addAppointments', data.results)
        }
      }
    },
    rescheduleAppointment ({commit, getters}, data) {
      if (data) {
        let appt = getters.getAppointment(data.id)
        // console.log(appt)
        if (appt) {
          appt = JSON.parse(JSON.stringify(appt)) // create a clone
          // remove from current index
          if (data.original_start_time && data.original_start_time.indexOf('T') > 0) {
            let oldDate = data.original_start_time.split('T')[0]
            let options = {id: appt.id, practitionerId: appt.practitioner, dt: oldDate}
            commit('cleanAppointment', options)
          }

          appt.dt = data.new_start_time.split('T')[0]
          appt.start_time = data.new_start_time
          appt.end_time = data.new_end_time
          commit('addAppointments', [appt])

          // if (data && data.original_start_time) {
          //   let dt = data.original_start_time.split('T')[0]
          //   commit('resetCalendarDayList', {appt, dt})
          // }
          // if (data && data.new_start_time) {
          //   let dt = data.new_start_time.split('T')[0]
          //   commit('resetCalendarDayList', {appt, dt})
          // }
        }
      }
      // appt_id: 135456
      // original_end_time: "2021-02-22T10:15:00%2000:00"
      // original_start_time: "2021-02-22T09:45:00%2000:00"
    }
  },
  getters: {
    getEventRange (state) {
      return Object.values(state.objects)
    },
    getRecentlyUpdated (state) {
      return state.recentlyUpdated
    },
    getAppointment: (state) => (id) => {
      if (id in state.objects) {
        return state.objects[id]
      }
      return null
    },
    getCalendarsDay: (state) => (calendarIds, dt) => {
      let events = []
      calendarIds.forEach((calendarId) => {
        if (state.calendars && state.calendars[calendarId] && state.calendars[calendarId].dates[dt]) {
          events = events.concat(state.calendars[calendarId].dates[dt].list)
        }
      })
      events = events.sort((a, b) => {
        if (a.start_time > b.start_time) { return 1 }
        if (a.start_time < b.start_time) { return -1 }
        return 0
      })
      return events
    },
    getCalendarDay: (state) => (calendarId, dt) => {
      let path = `calendars.${calendarId}.dates.${dt}.list`
      return getObjectPath(state, path, [])
      // if (state.calendars && state.calendars[calendarId] && state.calendars[calendarId].dates[dt]) {
      //   return state.calendars[calendarId].dates[dt].list
      // }
      // return []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appointments.js